"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var camelCaseToDash = function (s) {
    return s.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
};
exports.default = camelCaseToDash;
//# sourceMappingURL=camelCaseToDash.js.map